<template>
  <div v-editable="blok" class="blog-picture">
    <figure>
      <NuxtImg
        format="webp"
        :width="756"
        height="auto"
        :loading="blok.loading || 'lazy'"
        :sizes="`sm:640 md:756 lg:900`"
        provider="storyblok"
        :src="blok.image?.filename"
        :alt="blok.image?.alt || ''"
        class="blog-picture__image"
      />
      <figcaption v-if="hasCaption" v-html="content" />
    </figure>
  </div>
</template>

<script lang="ts" setup>
import type { SbBlogPictureStoryblok } from '@/types'

interface Props {
  blok: SbBlogPictureStoryblok
}
const props = defineProps<Props>()

const { decodeAndReplaceText } = useTextModifiers()

const encodedRichText = computed(() => {
  return JSON.parse(
    decodeAndReplaceText(JSON.stringify(props.blok.description)),
  )
})

const isRichtext = computed(() => {
  return typeof props.blok.description === 'object'
})

const content = computed(() => {
  return isRichtext.value
    ? renderRichText(encodedRichText.value)
    : props.blok.description
})

const hasCaption = computed(() => {
  return (
    (!isRichtext.value && content.value !== '') ||
    (isRichtext.value && 'content' in props.blok.description.content[0])
  )
})
</script>

<style lang="scss" scoped>
/* we use div wrapper and tag selector instead of class because of a bug that prevents class from being assigned
  to figure or figcaption */
.blog-picture {
  position: relative;
  width: 100%;

  @media (min-width: $breakpoint-md) {
    width: calc(100% + 96px);
    right: 48px;
  }

  &__image {
    object-fit: contain;
    max-width: 756px;
    width: 100%;
    height: 100%;
    border-radius: var(--border-radius-base);
  }

  & figcaption {
    @include paragraph-xs;

    text-align: left;
    margin: 16px 0 0;
    color: var(--navy-400);
  }
}
</style>
